import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import * as AddPhoneNumberActions from './add-phone-number.actions';

export const addPhoneNumberFeatureKey = 'addPhoneNumber';

export interface AddPhoneNumberState {
   callState: CallState;
   accountId: number | null;
   accountName: string | null;
}

export const initialState: AddPhoneNumberState = {
   callState: LoadingState.Init,
   accountId: null,
   accountName: null,
};

const addPhoneNumberReducer = createReducer(
   initialState,
   onReset(initialState),
   on(AddPhoneNumberActions.createPhoneNumber, AddPhoneNumberActions.createPhoneNumberAndAddAnother, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),

   on(
      AddPhoneNumberActions.createPhoneNumberSuccess,
      AddPhoneNumberActions.createPhoneNumberFailure,
      AddPhoneNumberActions.createPhoneNumberAndAddAnotherSuccess,
      AddPhoneNumberActions.createPhoneNumberAndAddAnotherFailure,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Loaded,
         };
      }
   ),
   on(AddPhoneNumberActions.createPhoneNumberAndAddAnotherSuccess, (state, { accountId, accountName }) => {
      return {
         ...state,
         accountId,
         accountName,
      };
   })
);

export function reducer(state: AddPhoneNumberState | undefined, action: Action) {
   return addPhoneNumberReducer(state, action);
}
